export default {
  ZUS: {
    store(data) {
      let zusemployer = JSON.parse(JSON.stringify(data.zusemployer));
      zusemployer.person = parseInt(zusemployer.person);
      return axios.post(import.meta.env.VITE_SITE_URL + '/crms/zus-employers', {
        zusemployer,
      });
    },
    index(url) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/zus-employers' + url,
        {
          params: {},
        },
      );
    },
    show(id) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/zus-employers/' + id,
        {
          params: {},
        },
      );
    },
    update(zus) {
      return axios.put(import.meta.env.VITE_SITE_URL + '/crms/zus-employers/' + zus.id, { zusemployer: zus });
    },
    delete(id) {
      return axios.delete(import.meta.env.VITE_SITE_URL + '/crms/zus-employers/' + id,
      );
    },

    calculateByPeriod(period, params = {}) {
      if (!period.toString().match(/^\d{4}\-\d{2}$/)) {
        throw { message: '`period` arg error', data: { period, params } };
      }

      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/zus-employers/calculate-by-period/' + period,
        {
          params,
        },
      );
    },
    calculateByPeriodEmployees(period) {
      if (!period.toString().match(/^\d{4}\-\d{2}$/)) {
        throw { message: '`period` arg error', data: { period, params } };
      }
      let date = new Date(period);

      return axios.post(import.meta.env.VITE_SITE_URL + '/crms/zus-employers/calculate-by-period/employees',
        {
          'month': date.getMonth() + 1,
          'year': date.getFullYear(),
        },
      );
    },
    zusBasesForInsuredEmployees(
      {
        period,
        insuranceCode,
        boss_id,
        usingZusVacation,
        usingZusVacationSocial,
        usingZusVacationSickness,
      },
      config = {},
    ) {
      if (!period.toString().match(/^\d{4}\-\d{2}$/)) {
        throw { message: '`period` arg error', data: { period, params } };
      }
      let date = new Date(period);

      return axios.post(
        import.meta.env.VITE_SITE_URL + '/crms/zus-employers/get-zus-bases',
        {
          'month': date.getMonth() + 1,
          'year': date.getFullYear(),
          insuranceCode,
          boss_id,
          usingZusVacation,
          usingZusVacationSocial,
          usingZusVacationSickness,
        },
        config,
      );
    },
    reCalculateDuesForEmployee(type, dues_data, period, changeBaseHealth = false, {
      usingZusVacation = false,
      usingZusVacationSocial = false,
      usingZusVacationSickness = false,
    }) {
      let data = {
        'type': type,
        'base_health_contributions': dues_data.base_health_contributions,
        'e_r_ch_amount': dues_data.e_r_ch_amount,
      };
      const date = new Date(period);
      switch (type) {
        case 'bill':
          data.bill_id = dues_data.id;
          data.base_health_contributions = changeBaseHealth ? dues_data.base_health_contributions : null;
          break;
        case 'payroll':
          data.payment_id = dues_data.payment_id;
          data.payroll_id = dues_data.payroll_id;
          data.base_health_contributions = changeBaseHealth ? dues_data.base_health_contributions : null;
          break;
        case 'new':
          if (!period.toString().match(/^\d{4}\-\d{2}$/)) {
            throw { message: '`period` arg error', data: { period } };
          }
          data.year = date.getFullYear();
          data.month = date.getMonth() + 1;
          break;
        case 'employer':
          data.companyType = dues_data.taxes_data.companyType;
          data.companyFormOfAccounting = dues_data.taxes_data.companyFormOfAccounting;
          data.agreesToTheDiseaseFrom = dues_data.taxes_data.agreesToTheDiseaseFrom;
          data.haveIncomeFromCivilLawContract = dues_data.taxes_data.haveIncomeFromCivilLawContract;
          data.preferenceZusCivilLawIncome = dues_data.taxes_data.preferenceZusCivilLawIncome;
          data.isEmploymentContract = dues_data.taxes_data.isEmploymentContract;
          data.hasPensionRight = dues_data.taxes_data.hasPensionRight;
          data.hasRetirementRight = dues_data.taxes_data.hasRetirementRight;
          data.startReductionFrom = dues_data.taxes_data.startReductionFrom;
          data.startReductionTo = dues_data.taxes_data.startReductionTo;
          data.usingPreferenceZusFrom = dues_data.taxes_data.usingPreferenceZusFrom;
          data.usingPreferenceZusTo = dues_data.taxes_data.usingPreferenceZusTo;
          data.taxType = dues_data.taxes_data.taxType;
          data.accidentRate = dues_data.taxes_data.accidentRate;
          data.pensionRate = dues_data.taxes_data.pensionRate;
          data.retirementRate = dues_data.taxes_data.retirementRate;
          data.sicknessRate = dues_data.taxes_data.sicknessRate;
          data.fpRate = dues_data.taxes_data.fpRate;
          data.lowestNationalWage = dues_data.taxes_data.lowestNationalWage;
          data.lowestNationalWageForFus = dues_data.taxes_data.lowestNationalWageForFus;
          data.averageSalaryForecast = dues_data.taxes_data.averageSalaryForecast;
          data.usingSmallZusFrom = dues_data.taxes_data.usingSmallZusFrom;
          data.usingSmallZusTo = dues_data.taxes_data.usingSmallZusTo;
          data.smallZusBase = dues_data.taxes_data.smallZusBase;
          data.averageSalaryCorporateSector = dues_data.taxes_data.averageSalaryCorporateSector;
          data.usingZusVacation = usingZusVacation;
          data.usingZusVacationSocial = usingZusVacationSocial;
          data.usingZusVacationSickness = usingZusVacationSickness;
          data.year = date.getFullYear();
          data.month = date.getMonth() + 1;
          data.healthContributionBase = dues_data.taxes_data.healthContributionBase;
          data.hasMalyZusFullFp = dues_data.taxes_data.hasMalyZusFullFp;
          data.base_health_contributions = changeBaseHealth ? data.base_health_contributions : dues_data.taxes_data.healthContributionBase;
          break;
        }
        return axios.post(import.meta.env.VITE_SITE_URL + '/crms/zus-employers/calculate-bases', data);
      },
      zusBasesForZusFunds(period, insuranceCode, boss_id) {
        if(!period.toString().match(/^\d{4}\-\d{2}$/)) {
          throw {message: '`period` arg error', data: {period, params}};
      }
      let date = new Date(period);

      return axios.post(import.meta.env.VITE_SITE_URL + '/crms/zus-employers/zus-funds',
        {
          'month': date.getMonth() + 1,
          'year': date.getFullYear(),
          'insuranceCode': insuranceCode,
          'boss_id': boss_id,
        },
      );
    },
  },
  DICTIONARY: {
    index() {
      return axios.get(
        import.meta.env.VITE_SITE_URL + '/crms/zus-fund-types',
        {
          params: {
            list: true,
          },
        },
      );
    },
  },
};
